import React, { useState, useRef, useEffect } from "react"

const ClaimedStatus = ({ claimed, proId, bookableUrl }) => {
    const [showTip, setShowTip] = useState(false)
    const wrapperRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowTip(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const claimUrl = `${bookableUrl}/pro/register/claim/${proId}`

    return (
        <span className={`claimed-status ${claimed ? 'claimed' : 'unclaimed'}`} ref={wrapperRef}>
            <button
                type="button"
                className={`claimed-status-label ${claimed ? 'claimed' : 'unclaimed'}`}
                onClick={() => setShowTip(!showTip)}
            >
                <span className="claimed-status-text">{claimed ? 'Claimed' : 'Unclaimed'}</span>
                {!claimed && (
                    <svg className="claimed-status-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="16" x2="12" y2="12" />
                        <line x1="12" y1="8" x2="12.01" y2="8" />
                    </svg>
                )}
            </button>
            {showTip && (
                <div className="claimed-status-tooltip">
                    {claimed ? (
                        'This business has been claimed by the owner or a representative.'
                    ) : (
                        <>
                            This business has not yet been claimed by the owner or a representative.{' '}
                            <a href={claimUrl}>Claim this business</a> for free to manage business details and receive customer requests.
                        </>
                    )}
                </div>
            )}
        </span>
    )
}

export default ClaimedStatus
